/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerLandingConfig } from '../../config/header.config';
import { AppNavigatorService } from '@/AppNavigator';
import { vappContainer } from '@/application';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IHeaderNavItemsPluginMethods extends IPluginMethodMap {
  getHeaderNavItemsSync(args?: any): any;
}

export class HeaderNavItemsPlugin implements IAgentPlugin {
  readonly methods: IHeaderNavItemsPluginMethods;

  constructor() {
    this.methods = {
      getHeaderNavItemsSync: this.getGetHeaderButton.bind(this),
    };
  }

  private async getGetHeaderButton() {
    // let user = await getWhoamiSrv()?.whoAmI();
    let user = await loginSrv()?.whoAmI();
    console.log(`user role`, user);
    if (user?.whoami !== null) {
      return { ...(headerLandingConfig?.buttonItem || {}) };
    } else {
      return { ...(headerLandingConfig?.buttonItem || {}) };
    }
  }
}
